// Analytics events. Sends to GA4 when REACT_APP_GA_ID is set (see public/index.html), otherwise no-op.
export const track = (event, props = {}) => {
    try {
        if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag("event", event, props);
    } catch (e) {
        /* ignore */
    }
};
